import { jsonldRecipeYield } from './JsonldStore';

export const updateJsonldRecipeYield = (value) => jsonldRecipeYield.update((oldValue) => value);
